export default __webpack_public_path__ + "assets/error-sorry-1-small.png";